import HomeIcon from '@mui/icons-material/Home';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import { Breadcrumbs, Link } from '@mui/material';
import React from 'react';

const ModernBreadcrumbs = ({ currentPath, onNavigate, isDarkBackground = false, maxItems = 8 }) => {
    // Generate breadcrumbs
    const generateBreadcrumbs = () => {
        if (currentPath === '/') {
            return [];
        }
        
        const pathParts = currentPath.split('/').filter(Boolean);
        const breadcrumbs = [];
        let currentPathBuilder = '';
        
        for (const part of pathParts) {
            currentPathBuilder += '/' + part;
            breadcrumbs.push({
                name: part,
                path: currentPathBuilder
            });
        }
        
        return breadcrumbs;
    };
    
    const breadcrumbs = generateBreadcrumbs();
    
    const navigateToHome = () => {
        onNavigate({
            name: 'Home',
            path: '/'
        });
    };
    
    const navigateToBreadcrumb = (crumb) => {
        onNavigate({
            name: crumb.name,
            path: crumb.path
        });
    };
    
    return (
        <Breadcrumbs
            separator={
                <NavigateNextIcon 
                    fontSize="small" 
                    sx={{ color: isDarkBackground ? '#ffffff' : 'inherit' }} 
                />
            }
            aria-label="breadcrumb"
            sx={{
                '& .MuiBreadcrumbs-ol': {
                    flexWrap: { xs: 'nowrap', sm: 'wrap' },
                    overflowX: { xs: 'auto', sm: 'visible' },
                    scrollbarWidth: 'thin',
                    '&::-webkit-scrollbar': {
                        height: '4px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                        borderRadius: '4px',
                    },
                },
                '& .MuiBreadcrumbs-li': {
                    whiteSpace: 'nowrap',
                },
                flexGrow: 1,
                '& .MuiBreadcrumbs-ol': {
                    color: isDarkBackground ? '#ffffff' : 'inherit'
                }
            }}
            maxItems={maxItems}
            itemsBeforeCollapse={maxItems <= 1 ? 0 : 1}
            itemsAfterCollapse={maxItems <= 2 ? 1 : 2}
        >
            <Link 
                sx={{ 
                    display: 'flex', 
                    alignItems: 'center',
                    textDecoration: 'none',
                    '&:hover': { textDecoration: 'underline' },
                    cursor: 'pointer',
                    color: isDarkBackground ? '#ffffff' : 'inherit'
                }}
                onClick={navigateToHome}
                underline="hover"
            >
                <HomeIcon 
                    sx={{ mr: 0.5, color: isDarkBackground ? '#ffffff' : 'inherit' }} 
                    fontSize="inherit" 
                />
                {maxItems > 2 ? 'Home' : ''}    
            </Link>
            
            {breadcrumbs.map((crumb, index) => (
                <Link
                    key={crumb.path}
                    sx={{ 
                        textDecoration: 'none',
                        '&:hover': { textDecoration: 'underline' },
                        cursor: 'pointer',
                        color: isDarkBackground ? '#ffffff' : 'inherit'
                    }}
                    onClick={() => navigateToBreadcrumb(crumb)}
                    underline="hover"
                >
                    {crumb.name}
                </Link>
            ))}
        </Breadcrumbs>
    );
};

export default ModernBreadcrumbs;